import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component MessageStarIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <MessageStarIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <MessageStarIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const MessageStarIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="MessageStarIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M11 4v2H6v11.26L10.39 15H18v-2h2v2a2 2 0 0 1-2 2H9.995L4 21V6a2 2 0 0 1 2-2z"
        clipRule="evenodd"
      />
      <path d="m17.069 9.783-2.145 1.128a.408.408 0 0 1-.591-.43l.41-2.388-1.736-1.691a.408.408 0 0 1 .226-.696l2.398-.348 1.072-2.173a.408.408 0 0 1 .732 0l1.072 2.173 2.398.348a.408.408 0 0 1 .226.696l-1.735 1.691.41 2.388a.408.408 0 0 1-.592.43z" />
    </svg>
  )
);
MessageStarIcon.displayName = "MessageStarIcon";
export default MessageStarIcon;
